import React from 'react';
import {Link} from 'react-router-dom';
import Col from 'antd/es/col';
import Row from 'antd/es/row';
import './Footer.css';

function Footer() {
  return (
      <Row className="footer-section">
        <Col span={24}>
          <div className="container footer-section-inner">
            <Row gutter={32}>
              <Col xs={24} sm={8} md={6}>
                <Link to={'/'}>
                  <img
                      className="footer-icon"
                      src={'https://assets-new.medcampus.io/assets/images/mc-logo.jpg'}
                      alt={'MedCampus icon'}/>
                </Link>
              </Col>
              <Col xs={12} sm={8} md={5}>
                <ul>
                  {/* <li><Link to={'/playwin/'}>Play & Win</Link></li> */}
                  <li><Link to={'/features/'}>Our Features</Link></li>
                  <li><Link to={'/about-us/'}>About us</Link></li>
                  <li><Link to={'/contact-us/'}>Contact us</Link></li>
                </ul>
              </Col>
              <Col xs={12} sm={8} md={5}>
                <ul>
                  <li><Link to={'/medpass/'}>medPass</Link></li>
                  <li><Link to={'/faqs/'}>FAQ's</Link></li>
                  <li><Link to={'/terms-and-conditions/'}>Terms of use</Link>
                  </li>
                  <li><Link to={'/privacy-policy/'}>Privacy Policy</Link></li>
                </ul>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <p className="follow-us mc-mt-20">Follow us :
                  <span className="social-media-icons">
                                <a href={'https://www.facebook.com/medcampus.io'}
                                   rel="noopener noreferrer"
                                   target="_blank">
                                    <img
                                        src={'https://assets-new.medcampus.io/assets/images/social-media-icons/facebook.svg'}
                                        alt="facebook" width={50}/>
                                 </a>
                                <a href={'https://www.instagram.com/medcampus.io/'}
                                   rel="noopener noreferrer"
                                   target="_blank">
                                    <img
                                        src={'https://assets-new.medcampus.io/assets/images/social-media-icons/instagram.svg'}
                                        alt="instagram" width={50}/>
                                 </a>
                                <a href={'https://www.youtube.com/channel/UCWR0A2LqbKe0LrfJIL1Olzg'}
                                   rel="noopener noreferrer" target="_blank">
                                    <img
                                        src={'https://assets-new.medcampus.io/assets/images/social-media-icons/youtube.svg'}
                                        alt="youtube" width={50}/>
                                 </a>
                            </span>
                </p>
                <p>
                  {/* <a
                      href="https://play.google.com/store/apps/details?id=com.medcampus"
                      target="_blank"
                  >
                    <img
                        src="https://assets-new.medcampus.io/assets/images/Google-Play-Store.png"
                        width={100}
                        alt="Android app download"
                        className="mc-mr-5 mc-ml-5 mc-mt-5"
                    />
                  </a> */}
                  {/* <a
                      href="https://apps.apple.com/us/app/medcampus-medical-education/id1503887165?ls=1"
                      target="_blank"
                  >
                    <img
                        src="https://assets-new.medcampus.io/assets/images/Apple-App-Store.png"
                        width={100}
                        alt="Android app download"
                        className="mc-mr-5 mc-ml-5 mc-mt-5"
                    />
                  </a> */}
                </p>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <p className="text-center mc-mtb-30"><b>{new Date().getFullYear()} © MedCampus. All Rights Reserved.</b></p>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
  );
}

export {Footer};
